import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LocationProvider } from './context/LocationContext';
import SideNav   from './components/SideNav';
import BottomNav from './components/BottomNav';
import HomePage          from './pages/HomePage';
import HospitalListPage  from './pages/HospitalListPage';
import HospitalDetailPage from './pages/HospitalDetailPage';
import OpBookingPage     from './pages/OpBookingPage';
import DoctorBookingPage from './pages/DoctorBookingPage';
import MyBookingsPage    from './pages/MyBookingsPage';
import BookingDetailPage from './pages/BookingDetailPage';
import EmergencyPage     from './pages/EmergencyPage';
import LoginPage             from './pages/LoginPage';
import ProfilePage           from './pages/ProfilePage';
import FindDoctorPage        from './pages/FindDoctorPage';
import PrivacyPolicy         from './pages/PrivacyPolicy';
import TermsAndConditions    from './pages/TermsAndConditions';
import ReferEarnPage         from './pages/ReferEarnPage';
import SupportPage           from './pages/SupportPage';
import PrescriptionsPage     from './pages/PrescriptionsPage';
import ReviewPrompt          from './components/ReviewPrompt';
import LocationAutoPrompt    from './components/LocationAutoPrompt';
import './index.css';

const PaymentPage = React.lazy(() => import('./pages/PaymentPage'));
const OnboardingPage = React.lazy(() => import('./pages/OnboardingPage'));

function Shell({ children }) {
  return (
    <div className="app-shell">
      <SideNav />
      <main className="main-content">{children}</main>
      <BottomNav />
      <ReviewPrompt />
      <LocationAutoPrompt />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LocationProvider>
        <Routes>
          {/* ── Public legal pages (no nav/shell) ── */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/onboarding" element={<React.Suspense fallback={<div/>}><OnboardingPage /></React.Suspense>} />
        <Route path="/terms"   element={<TermsAndConditions />} />

          {/* ── All other pages (with Shell nav) ── */}
          <Route path="/*" element={
            <Shell>
              <Routes>
                <Route path="/"                         element={<HomePage />} />
                <Route path="/hospitals"                element={<HospitalListPage />} />
                <Route path="/hospitals/:id"            element={<HospitalDetailPage />} />
                <Route path="/book/op/:hospitalId"      element={<OpBookingPage />} />
                <Route path="/book/doctor/:doctorId"    element={<DoctorBookingPage />} />
                <Route path="/bookings"                 element={<MyBookingsPage />} />
                <Route path="/bookings/:bookingId"      element={<BookingDetailPage />} />
                <Route path="/emergency"                element={<EmergencyPage />} />
                <Route path="/login"                    element={<LoginPage />} />
                <Route path="/find-doctor"              element={<FindDoctorPage />} />
                <Route path="/profile"                  element={<ProfilePage />} />
                <Route path="/refer"                    element={<ReferEarnPage />} />
                <Route path="/support"                  element={<SupportPage />} />
                <Route path="/prescriptions"            element={<PrescriptionsPage />} />
                <Route path="/payment" element={<React.Suspense fallback={<div/>}><PaymentPage /></React.Suspense>} />
              </Routes>
            </Shell>
          } />
        </Routes>
        </LocationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
